import React from 'react';

import { useProjectContext, useProjectContextDispatch } from '@contexts/ProjectContext';

import ProjectContacts from '@components/Project/ProjectContacts/ProjectContacts';
import ProjectContracts from '@components/Project/ProjectContracts/ProjectContracts';
import ProjectDocuments from '@components/Project/ProjectDocuments/ProjectDocuments';
import ProjectTransactions from '@components/Project/ProjectTransactions/ProjectTransactions';

import EventDrawerTabs from './EventDrawerTabs';

const EventDrawerTabsWithContext = ({ firstTab, eventData, filterModel }) => {
    const { layout } = useProjectContext();
    const projectDispatch = useProjectContextDispatch();

    const handleSetLayout = (newLayout) => {
        projectDispatch({ type: 'SetLayout', layout: newLayout });
    };

    const tabs = [
        firstTab,
        <ProjectTransactions eventData={eventData} mode="event" modelId={filterModel} />,
        <ProjectContacts mode="event" isDrawer={true} />,
        <>
            <ProjectDocuments modelId={filterModel} vertical />
            <ProjectContracts vertical />
        </>,
    ];

    return <EventDrawerTabs tabs={tabs} activeKey={layout} onSetLayout={handleSetLayout} />;
};

export default EventDrawerTabsWithContext;
